let language = {
    RANDOM_DESIGN_ITEM_INFO_DELETE_ITEM_TITLE: "delete",
    RANDOM_DESIGN_ITEM_INFO_VALIDATE_TITLE_CONTENT: "Whether to remove the current gallery ratio",
    RANDOM_DESIGN_ITEM_INFO_DELETE_ITEM_TITLE_CONTENT: "Whether to remove the current gallery ratio",
}
export { language }